import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FormGroup, Table, Input, Label, Form, Card, CardHeader,CardFooter, CardText, CardBody, Button } from 'reactstrap';
import '../GerenciamentoTurmas/GerenciamentoTurmas.css';
import { useMediaQuery } from 'react-responsive';
import { Search, Envelope } from 'react-bootstrap-icons';

const RegistroPessoalAluno = (props) => {
    const [alunoSelecionado, setAlunoSelecionado] = useState(JSON.parse(localStorage.getItem("alunoSelecionado")));
    const [registrosALuno, setRegistrosAluno] = useState();
    const [dataInicio, setDataInicio] = useState(null);
    const [dataFim, setDataFim] = useState(null);
    let username = process.env.REACT_APP_ANJO_BACKEND_USER
    let password = process.env.REACT_APP_ANJO_BACKEND_PSW

    const isDesktopOrLaptop = useMediaQuery({ query: '(min-width: 769px)' })
    const isTabletOrMobile = useMediaQuery({ query: '(max-width: 768px)' })


    const checkForEnter = (e) => {
        let key = e.key;
        if (key === "Enter" || key === "NumpadEnter") {
            fillRegistrosAluno();
        }
    }

    const defaultDateHoje = () => {
        const today = new Date();
        const date = today.setDate(today.getDate());
        const defaultValue = new Date(date).toISOString().split('T')[0] 
        return defaultValue
    }

    const fillRegistrosAluno = async () => {
        
        let dataInicioString = JSON.stringify(dataInicio);
        let dataFimString = JSON.stringify(dataFim);
        const response = await axios.post("/aluno/registros/" + alunoSelecionado.cdAluno, {
            dataInicio, dataFim
        },
            {
                auth: {
                    username,
                    password
                }
            });
       localStorage.setItem('registrosAluno', JSON.stringify(response.data));
       setRegistrosAluno(response.data);
    }

    const renderRegistrosAluno = () => {
        let renderedList = [];
        for (let registro of registrosALuno) {
            renderedList.push(renderRegistroSingle(registro));
        }
        return renderedList;
    }

    const dataHoraFormatados = (dataRaw) => {
        const date = new Date(dataRaw);

        const formattedDate = date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });

        const formattedTime = date.toLocaleTimeString('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        });

        let formattedDateTime = `${formattedDate} : ${formattedTime}`;

        return formattedDateTime;
    }

    const renderRegistroSingle = (registro) => {
        return (
           <>
            <Card className="my-2" className="TabelaResgistroAluno">
                <CardHeader className="cardHeaderFooter">
                        {dataHoraFormatados(registro["dataRegistro"])}
                        {registro.isEntradaManual ? <Envelope className="envelopeRegistroManual" size="20"
                            onClick={() => alert(registro.notaManual) }/> : ""}
                </CardHeader>
                <CardBody className="cardHeaderFooter">
                    <CardText className="cardTextRegistoAluno">
                            Responsável: <div className="bubbleInfoRefistro">{registro["nomeResponsavel"]}</div>
                            Vínculo:  <div className="bubbleInfoRefistro">{registro["vinculoFilial"]} </div>
                                Registro: <div className="bubbleInfoRefistro">{registro["tipoTransaccao"]} </div>
                    </CardText>
                </CardBody>
                <CardFooter className="cardHeaderFooter">
                        Funcionário: {registro["matriculaFuncionario"]}
                </CardFooter>
            </Card>
            <br/>
           </>
        );
    }

    return (
        <>
            {isTabletOrMobile &&
                (<><label>Datas Inicio/Fim:</label>
                <h2 className="titulosPaginas">Registros</h2>
                <h5 className="titulosPaginas">{alunoSelecionado.nome}</h5>
            <Form className="dataForm">
                <FormGroup className="dataFormGroup">
                    <Input
                        className="dataInput"
                        id="pesquisa"
                        name="inicio"
                        type="date"
                        defaultValue={defaultDateHoje()}
                        onKeyPress={() => checkForEnter()}
                        onChange={(e) => setDataInicio(e.target.value)}
                        onBlur={(e) => setDataInicio(e.target.value)}
                    />
                </FormGroup>
                <FormGroup className="dataFormGroup">
                    <Input
                        className="dataInput"
                        id="pesquisa"
                        name="fim"
                        type="date"
                        defaultValue={defaultDateHoje()}
                        onKeyPress={() => checkForEnter()}
                        onChange={(e) => setDataFim(e.target.value)}
                        onBlur={(e) => setDataFim(e.target.value)}
                    />
                </FormGroup>
                <FormGroup className="dataFormGroup">
                    <Button className="searchDataButton" onClick={() => fillRegistrosAluno()}>
                        <Search />
                    </Button>
                </FormGroup>
                </Form></>)}

            {isDesktopOrLaptop && (
                <>
                    <h2 className="titulosPaginas">Registros</h2>
                    <h5 className="titulosPaginas">{alunoSelecionado.nome}</h5>
                    <Form className="dataForm">
                    <FormGroup className="dataFormGroup">
                        <div className="labelData">Inicio:</div>
                        <Input
                            className="dataInput"
                            id="pesquisa"
                            name="inicio"
                            type="date"
                            defaultValue={defaultDateHoje()}
                            onKeyPress={() => checkForEnter()}
                            onChange={(e) => setDataInicio(e.target.value)}
                            onBlur={(e) => setDataInicio(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup className="dataFormGroup">
                        <div className="labelData">Fim:</div>
                        <Input
                            className="dataInput"
                            id="pesquisa"
                            name="fim"
                            type="date"
                            defaultValue={defaultDateHoje()}
                            onKeyPress={() => checkForEnter()}
                            onChange={(e) => setDataFim(e.target.value)}
                            onBlur={(e) => setDataFim(e.target.value)}
                        />
                    </FormGroup>
                    <FormGroup className="dataFormGroup">
                        <Button className="searchDataButton" onClick={() => fillRegistrosAluno()}>
                            <Search />
                        </Button>
                    </FormGroup>
                </Form></>)}
            
            <FormGroup>
                <div className="CardConfig">
                    {registrosALuno && renderRegistrosAluno()}
                </div>
            </FormGroup>
        </>
    );
}

export default RegistroPessoalAluno;
